function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 11.667 11.667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.424 0.582 L 4.424 3.402 C 4.789 2.84 5.21 2.315 5.685 1.841 C 6.156 1.368 6.679 0.947 7.243 0.582 L 4.424 0.582 Z",
    style: {
      fill: "rgb(78, 78, 78)"
    },
    transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 3.117149, -3.541464)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillOpacity: 0,
      fill: "rgb(190, 181, 140)",
      paintOrder: "stroke",
      stroke: "rgb(78, 78, 78)",
      strokeWidth: "0.5px"
    },
    cx: 5.834,
    cy: 5.834,
    rx: 4.071,
    ry: 4.071
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.d2df6d90a2076f1640d80aba29185808.svg";
export { ForwardRef as ReactComponent };